import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import Loader from './elements/Loader';

//Redux
import { Provider } from 'react-redux'
import store from './redux/store'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<div className={'flex justify-center h-screen items-center'}><Loader show /></div>}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
